import(/* webpackMode: "eager" */ "/vercel/path0/Website/components/mobileApp/AppDownload.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/Website/node_modules/next/dist/client/link.js")